import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Toast } from "primeng/toast";
import { MessageService } from "primeng/api";
import { LanguageService } from "./services/language.service";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { getPossibleLanguages, ILanguage } from "./models/language.model";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, Toast, TranslocoPipe],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  private languageService = inject(LanguageService);
  private messageService = inject(MessageService);
  private translocoService = inject(TranslocoService);

  languages: ILanguage[] = getPossibleLanguages();
  currentYear = new Date().getFullYear();

  get activeLanguage(): string {
    return this.translocoService.getActiveLang();
  }

  constructor() {
    this.languageService.initializeTranslateService();
  }

  switchLanguage(language: ILanguage): void {
    this.languageService.setLanguage(language.value);
  }

  getLanguageButtonClass(language: ILanguage): string {
    const isActive = this.activeLanguage === language.short;
    return isActive
      ? 'bg-white shadow-sm text-gray-900 font-semibold hover:bg-white'
      : 'bg-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50';
  }

  showToast() {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Tailwind CSS and PrimeNG are working correctly!',
      life: 3000
    });
  }
}
